module.exports = __webpack_public_path__ + "static/media/202-taiwan.3440e124.svg";